module.exports = __webpack_public_path__ + "img/AI (2).e5cb4d13.png";